import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./App.css";
import "./index.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  type AdobeDataLayer,
  initAdobeAnalytics,
  normalizeEnvironment,
  type TrackingObject,
} from "@playlive/adobe-analytics";

declare global {
  interface OneTrustType {
    ToggleInfoDisplay: () => void;
  }

  interface Window {
    OneTrust: OneTrustType;
    stjude: TrackingObject;
    adobeDataLayer: AdobeDataLayer;
  }
}

initAdobeAnalytics({
  siteCode: "playlive",
  environment: normalizeEnvironment(import.meta.env.VITE_ENV ?? "dev"),
  language: "english",
  defaultPageName: "home",
});

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
